import React from 'react';
import { useHistory } from 'react-router';
import { Typography, Link, Button } from '@branchjs/neo-components';

import { ScreenOutOfServiceStyles } from './ScreenOutOfService.styles';
import { ImageService } from '../../services/ImageService/ImageService';

const ScreenOutOfService = () => {
  const history = useHistory();

  const handleErrorBoundaryReset = () => {
    const currentDashboardView = (window as any)?.App?.context?.view?.current_product;

    if (currentDashboardView === 'disco') {
      history.push('/mobile-search/stats');
    } else {
      history.push('/');
    }
  };

  return (
    <div className={ScreenOutOfServiceStyles.ContentContainer}>
      <img
        className={ScreenOutOfServiceStyles.Image}
        src={ImageService.getImageUrl('/static/images/error/out-of-service.svg')}
        alt="Error Browser"
      />
      <Typography className={ScreenOutOfServiceStyles.Title} variant="h2">
        Uh-oh, something's not quite right.
      </Typography>
      <Typography className={ScreenOutOfServiceStyles.Description} variant="body1">
        We apologize for the inconvenience, but the page you are trying to access is currently out of service. Our team has
        received notification of the issue and is actively working to fix it as soon as possible.
      </Typography>
      <Link to="/">
        <Button variant="contained" color="primary" size="large" onClick={handleErrorBoundaryReset}>
          Back to Homepage
        </Button>
      </Link>
    </div>
  );
};

export default ScreenOutOfService;
